import { AuthViewModel } from "../viewmodels/AuthViewModel.js";
import { useSingleton } from "mvc-kit/react";
//#region src/modules/AuthWrapper2/hooks/useCurrentIdentityInfo.ts
function useCurrentIdentityInfo() {
	return useSingleton(AuthViewModel).state.identityInfo;
}
//#endregion
export { useCurrentIdentityInfo };

//# sourceMappingURL=useCurrentIdentityInfo.js.map